var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserNotLoggedInIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.24121 9.75717C3.24121 15.1236 7.63194 19.5143 12.9984 19.5143C18.3648 19.5143 22.7556 15.1236 22.7556 9.75717C22.7556 4.39073 18.3648 0 12.9984 0C7.63194 0 3.24121 4.39073 3.24121 9.75717ZM20.4598 9.75717C20.4598 13.8609 17.1021 17.2185 12.9984 17.2185C8.89463 17.2185 5.53702 13.8609 5.53702 9.75717C5.53702 5.65342 8.89463 2.29581 12.9984 2.29581C17.1021 2.29581 20.4598 5.65342 20.4598 9.75717Z",
    fill: "#ECECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.63576 29.9612C4.6777 26.9192 8.69536 25.2548 13 25.2548C17.3046 25.2548 21.3223 26.9192 24.3642 29.9612L26 28.3254C22.5276 24.8817 17.9073 22.959 13 22.959C8.09271 22.959 3.47241 24.8817 0 28.3254L1.63576 29.9612Z",
    fill: "#ECECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserNotLoggedInIcon);
export default __webpack_public_path__ + "static/media/user_not_logged_in_icon.efd5be25a3931aa6ba165aeb1ba4c027.svg";
export { ForwardRef as ReactComponent };